export class GetMemberAdsListRequest {
    KeywordSearches: string[];
    PageNumber: number;
    ItemsPerPage: number;
    Sorting: number;
    typeFilter: number;
    StatusSearch: number;
}